<template lang="pug">
  SubmitButton(
    :loading="loading"
    icon="fa fa-file-excel"
    :text="$t('ui.' + btnTxt)"
    type="button"
    @click="tableToExcelNew2()"
    variant="info"
    size="sm"
  )
</template>

<script>
import SubmitButton from "@/library/SubmitButton.vue";

export default {
  components: {
    SubmitButton
  },
  props: {
    mode: {
      type: String,
      default: ""
    },
    date: {
      type: Object,
      default: ""
    },
    tbl: {
      type: String,
      default: ""
    },
    btnTxt: {
      type: String,
      default: "export_excel"
    },
  },
  data(){
    return{
      loading: false,
      uri :'data:application/vnd.ms-excel;base64,',
      template:'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
      base64: function(s){ return window.btoa(unescape(encodeURIComponent(s))) },
      format: function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
    }
  },
  methods: {
    tableToExcel(){
      var table = this.tbl;
      this.loading = true;
      if (!table.nodeType) table = document.getElementById(table)
      var worksheetTitle = this.$moment(this.date.startDate).format("YYYYMMDD") + "-" + this.$moment(this.date.endDate).format("YYYYMMDD")
      var iHtml = table.innerHTML.toString().replaceAll('href="javascript:void(0);"', '').replaceAll('target="_self"', '');
      var ctx = {worksheet: worksheetTitle || 'Worksheet', table: iHtml}
      // window.location.href = this.uri + this.base64(this.format(this.template, ctx))
      var link = document.createElement("a")
      link.download = this.mode + "-" + this.$store.getters.accountId.toUpperCase() + "-" +  worksheetTitle +  ".xls"
      link.href = this.uri + this.base64(this.format(this.template, ctx))
      link.click()
      this.loading = false;
    },
    // tableToExcelNew2() {
    //   this.loading = true;

    //   // Get the table element
    //   var table = this.tbl;
    //   if (!table.nodeType) table = document.getElementById(table);

    //   // Convert table to a worksheet
    //   const ws = XLSX.utils.table_to_sheet(table);

    //   // Set column widths based on table content
    //   const tableHeaders = table.querySelectorAll('th');
    //   const colWidths = Array.from(tableHeaders).map(th => ({
    //     wch: th.innerText.length + 5 // Adjust column width dynamically (e.g., text length + padding)
    //   }));
    //   ws['!cols'] = colWidths;

    //   // Format date-time cells explicitly
    //   const dataRows = table.querySelectorAll('tr:not(.footer)');
    //   Array.from(dataRows).forEach((row, rowIndex) => {
    //     const cells = row.querySelectorAll('td');
    //     Array.from(cells).forEach((cell, colIndex) => {
    //       const cellValue = cell.innerText;

    //       // If the value looks like a date-time, format it explicitly
    //       if (/^\d{4}-\d{2}-\d{2}, \d{2}:\d{2}:\d{2}$/.test(cellValue)) {
    //         const excelCellRef = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
    //         ws[excelCellRef] = { t: 's', v: cellValue }; // Treat as text to preserve formatting
    //       } else {
    //         const excelCellRef = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
    //         // Explicitly treat all non-date or problematic values as text
    //         ws[excelCellRef] = { t: 's', v: cellValue }; 
    //       }
    //     });
    //   });

    //   // Create a workbook and append the worksheet
    //   const workbook = XLSX.utils.book_new();
    //   XLSX.utils.book_append_sheet(workbook, ws, "Sheet1");

    //   // Set the filename
    //   const worksheetTitle = this.$moment(this.date.startDate).format("YYYYMMDD") + "-" + this.$moment(this.date.endDate).format("YYYYMMDD");
    //   const filename = `${this.mode}-${this.$store.getters.accountId.toUpperCase()}-${worksheetTitle}.xlsx`;

    //   // Export to Excel file
    //   XLSX.writeFile(workbook, filename);

    //   this.loading = false;
    // },
    tableToExcelNew2() {
      // Get the table element
      let table = this.tbl;
      if (!table.nodeType) table = document.getElementById(table);
      if (!table) return;

      // Convert table to a worksheet
      const ws = XLSX.utils.table_to_sheet(table);

      // Set column widths based on table header content
      const tableHeaders = table.querySelectorAll('th');
      const colWidths = Array.from(tableHeaders).map(th => ({
        wch: th.innerText.length + 5 // Adjust width dynamically
      }));
      ws['!cols'] = colWidths;

      // Format data cells correctly (text/date/number)
      const dataRows = table.querySelectorAll('tr:not(.footer)');
      Array.from(dataRows).forEach((row, rowIndex) => {
        const cells = row.querySelectorAll('td');
        Array.from(cells).forEach((cell, colIndex) => {
          const cellValue = cell.innerText.trim();
          const excelCellRef = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });

          // Date-time detection (e.g., 2024-05-01, 12:34:56)
          if (/^\d{4}-\d{2}-\d{2}, \d{2}:\d{2}:\d{2}$/.test(cellValue)) {
            ws[excelCellRef] = { t: 's', v: cellValue }; // Keep as text
            return;
          }

          // Number detection (handles "1234" or "1,234.56")
          const numericValue = cellValue.replace(/,/g, '');
          if (!isNaN(numericValue) && numericValue !== '') {
            ws[excelCellRef] = { t: 'n', v: parseFloat(numericValue) };
            return;
          }

          // Default: treat as text
          ws[excelCellRef] = { t: 's', v: cellValue };
        });
      });

      // Create a workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, ws, "Sheet1");

      // Set filename
      const worksheetTitle = this.$moment(this.date.startDate).format("YYYYMMDD") + "-" + 
                            this.$moment(this.date.endDate).format("YYYYMMDD");
      const filename = `${this.mode}-${this.$store.getters.accountId.toUpperCase()}-${worksheetTitle}.xlsx`;

      // Export to Excel file
      XLSX.writeFile(workbook, filename);

      this.loading = false;
    }
  },
};
</script>